import React, { useRef, useState } from 'react';
import { ArrowRight, Check, CircleAlert, Database, Sparkles } from 'lucide-react';
import { WORKFLOW_GROUPS } from '../data/site';

export default function WorkflowSwitcher() {
  const [activeIndex, setActiveIndex] = useState(0);
  const tabRefs = useRef([]);

  const selectTab = (index) => {
    const nextIndex = (index + WORKFLOW_GROUPS.length) % WORKFLOW_GROUPS.length;
    setActiveIndex(nextIndex);
    tabRefs.current[nextIndex]?.focus();
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      selectTab(index + 1);
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      selectTab(index - 1);
    } else if (event.key === 'Home') {
      event.preventDefault();
      selectTab(0);
    } else if (event.key === 'End') {
      event.preventDefault();
      selectTab(WORKFLOW_GROUPS.length - 1);
    }
  };

  return (
    <div className="alt4-workflow-switcher">
      <div className="alt4-workflow-tabs" role="tablist" aria-label="Patient journey workflows">
        {WORKFLOW_GROUPS.map((workflow, index) => (
          <button
            key={workflow.id}
            ref={(node) => { tabRefs.current[index] = node; }}
            id={`workflow-tab-${workflow.id}`}
            type="button"
            role="tab"
            aria-selected={activeIndex === index}
            aria-controls={`workflow-panel-${workflow.id}`}
            tabIndex={activeIndex === index ? 0 : -1}
            onClick={() => setActiveIndex(index)}
            onKeyDown={(event) => handleKeyDown(event, index)}
          >
            <span>{workflow.label}</span>
            <ArrowRight aria-hidden="true" />
          </button>
        ))}
      </div>

      {WORKFLOW_GROUPS.map((workflow, index) => {
        const isActive = activeIndex === index;

        return (
          <section
            key={workflow.id}
            id={`workflow-panel-${workflow.id}`}
            className="alt4-workflow-panel"
            role="tabpanel"
            aria-labelledby={`workflow-tab-${workflow.id}`}
            tabIndex={isActive ? 0 : -1}
            hidden={!isActive}
          >
            <header className="alt4-workflow-panel__header">
              <span className="alt4-interface-label">{workflow.label}</span>
              <h3>{workflow.summary}</h3>
            </header>

            <div className="alt4-workflow-panel__flow">
              <article>
                <span className="alt4-workflow-panel__icon"><CircleAlert aria-hidden="true" /></span>
                <div><span>Trigger</span><strong>{workflow.trigger}</strong></div>
              </article>
              <ArrowRight aria-hidden="true" />
              <article>
                <span className="alt4-workflow-panel__icon"><Database aria-hidden="true" /></span>
                <div><span>Shared context</span><strong>{workflow.context}</strong></div>
              </article>
              <ArrowRight aria-hidden="true" />
              <article>
                <span className="alt4-workflow-panel__icon"><Sparkles aria-hidden="true" /></span>
                <div><span>Completed state</span><strong>{workflow.completed}</strong></div>
              </article>
            </div>

            <div className="alt4-workflow-panel__details">
              <div>
                <span className="alt4-interface-label">Actions in the run</span>
                <ul>
                  {workflow.actions.map((action) => (
                    <li key={action}><Check aria-hidden="true" /> {action}</li>
                  ))}
                </ul>
              </div>
              <div className="alt4-workflow-panel__exception">
                <span className="alt4-interface-label">When context is missing</span>
                <p>{workflow.exception}</p>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
